<main class="ca-page">
  <header class="ca-page-header">
    <div>
      <h1><mat-icon>account_balance_wallet</mat-icon> Взаиморасчёты с клиентами</h1>
      <p>Свободные деньги, обязательства по заказам и операции по организациям</p>
    </div>
    <button mat-stroked-button [disabled]="loading" (click)="reload()">
      <mat-icon>refresh</mat-icon>Обновить
    </button>
  </header>
  <form class="ca-filters" (ngSubmit)="apply()">
    <mat-form-field appearance="outline"
      ><mat-label>Организация</mat-label
      ><mat-select [(ngModel)]="orgId" name="org"
        ><mat-option *ngFor="let org of organizations" [value]="org.id">{{
          org.name
        }}</mat-option></mat-select
      ></mat-form-field
    >
    <mat-form-field appearance="outline"
      ><mat-label>Клиент / телефон / номер</mat-label
      ><input matInput [(ngModel)]="search" name="search"
    /></mat-form-field>
    <mat-form-field appearance="outline"
      ><mat-label>Состояние</mat-label
      ><mat-select [(ngModel)]="status" name="status"
        ><mat-option value="">Все</mat-option><mat-option value="DEBT">Есть долг</mat-option
        ><mat-option value="CREDIT">Есть свободные деньги</mat-option
        ><mat-option value="PENDING">В обработке</mat-option></mat-select
      ></mat-form-field
    >
    <mat-form-field appearance="outline"
      ><mat-label>Сортировка</mat-label
      ><mat-select [(ngModel)]="sort" name="sort">
        <mat-option value="client_name">Клиент</mat-option
        ><mat-option value="balance">Баланс</mat-option>
        <mat-option value="available_credit">Доступно</mat-option
        ><mat-option value="debt">Долг</mat-option>
        <mat-option value="overdue_debt">Просрочка</mat-option
        ><mat-option value="committed_credit">В заказах</mat-option>
        <mat-option value="reserved_credit">В обработке</mat-option></mat-select
      ></mat-form-field
    >
    <mat-form-field appearance="outline"
      ><mat-label>Порядок</mat-label
      ><mat-select [(ngModel)]="direction" name="direction">
        <mat-option value="asc">По возрастанию</mat-option
        ><mat-option value="desc">По убыванию</mat-option></mat-select
      ></mat-form-field
    >
    <button mat-flat-button color="primary" type="submit">
      <mat-icon>search</mat-icon>Показать
    </button>
  </form>
  <p class="ca-note">
    Положительный баланс — свободные деньги за вычетом долга. Оплаты ещё не отгруженных заказов
    показаны отдельно и не доступны для повторного зачёта.
  </p>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div
    class="ca-report-scroll"
    (scroll)="edge($event)"
    tabindex="0"
    aria-label="Клиентские взаиморасчёты"
  >
    <table class="ca-table">
      <thead>
        <tr>
          <th>Клиент</th>
          <th>Баланс</th>
          <th>Доступно</th>
          <th>В заказах</th>
          <th>Долг</th>
          <th>Просрочка</th>
          <th>В обработке / банк</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td>
            <a
              [routerLink]="['/client/profile', row.client_id]"
              [queryParams]="{ tab: 'settlements', org_id: row.org_id }"
              ><strong>{{ row.client_name || 'Клиент №' + row.client_id }}</strong></a
            ><small
              >№{{ row.client_id }} · {{ row.org_name }} ·
              {{ row.manager_name || 'Менеджер не назначен' }}</small
            ><small *ngIf="row.client_phone">{{ row.client_phone }}</small>
          </td>
          <td [class.ca-positive]="row.balance > 0" [class.ca-negative]="row.balance < 0">
            <b>{{ row.balance > 0 ? '+' : '' }}{{ row.balance | number: '1.2-2' }}</b>
          </td>
          <td class="ca-positive">{{ row.available_credit | number: '1.2-2' }}</td>
          <td>{{ row.committed_credit | number: '1.2-2' }}</td>
          <td class="ca-negative">{{ row.debt | number: '1.2-2' }}</td>
          <td class="ca-negative">{{ row.overdue_debt | number: '1.2-2' }}</td>
          <td>
            {{ row.reserved_credit | number: '1.2-2' }} / {{ row.pending_bank | number: '1.2-2' }}
          </td>
          <td>
            <button
              mat-stroked-button
              [disabled]="!row.enabled || !row.reconciled"
              (click)="topup(row)"
            >
              Пополнить
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="ca-empty" *ngIf="!loading && !error && !rows.length">
      Клиенты по выбранным условиям не найдены.
    </p>
  </div>
  <p class="ca-error" role="alert" *ngIf="error">
    {{ error }} <button mat-button (click)="loadMore()">Повторить</button>
  </p>
  <footer class="ca-footer">
    <span>Показано {{ rows.length }} из {{ total }}</span
    ><button mat-button *ngIf="rows.length < total" [disabled]="loading" (click)="loadMore()">
      Загрузить ещё
    </button>
  </footer>
</main>
